import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import AuthPage from "@/pages/AuthPage";
import HomePage from "@/pages/HomePage";
import ProgramPage from "@/pages/ProgramPage";
import ProgramDayPage from "@/pages/ProgramDayPage";
import FuelPage from "@/pages/FuelPage";
import ProgressPage from "@/pages/ProgressPage";
import ProfilePage from "@/pages/ProfilePage";
import WorkoutPage from "@/pages/WorkoutPage";
import CheckinPage from "@/pages/CheckinPage";
import MembershipPage from "@/pages/MembershipPage";
import AdminPage from "@/pages/AdminPage";

function Protected({ children, member = false, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (member && !user.is_member) return <Navigate to="/membership?locked=1" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return <AppShell>{children}</AppShell>;
}

function AuthRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-zinc-500">Loading…</div>;
  if (user) return <Navigate to="/" replace />;
  return <AuthPage />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/auth" element={<AuthRoute/>} />
          <Route path="/" element={<Protected><HomePage/></Protected>} />
          <Route path="/program" element={<Protected><ProgramPage/></Protected>} />
          <Route path="/program/:day" element={<Protected member><ProgramDayPage/></Protected>} />
          <Route path="/workout/:id" element={<Protected member><WorkoutPage/></Protected>} />
          <Route path="/fuel" element={<Protected><FuelPage/></Protected>} />
          <Route path="/progress" element={<Protected><ProgressPage/></Protected>} />
          <Route path="/profile" element={<Protected><ProfilePage/></Protected>} />
          <Route path="/checkin" element={<Protected><CheckinPage/></Protected>} />
          <Route path="/membership" element={<Protected><MembershipPage/></Protected>} />
          <Route path="/admin" element={<Protected admin><AdminPage/></Protected>} />
          <Route path="*" element={<Navigate to="/" replace/>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
